import { Button, Form, Input, notification, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { DeleteOutlined } from '@ant-design/icons'
import liracrypt from '../components/Liracrypt/liracrypt';
import ButtonPicker from '../components/ReportFormGenerator/Button/Button';

const ImageUpload = () => {
    const [form] = Form.useForm();
    const [img, setImg] = useState();
    const [partData, setPartData] = useState();
    const [responseImg, setResponseImg] = useState();
    const imgInputRef = useRef();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        liracrypt.get('/livo/livodict', {
            'mod': '',
            'pno': '',
            'opt': '',
            'typ': 'Model',
            'subTyp': 'idame'
        })
            .then(response => {
                let data = { ...response.data.data };
                let respData = [
                    { label: 'All', value: 'all' }
                ];
                // let respData = [

                // ];
                Object.keys(data).forEach(x => {
                    respData.push({
                        value: x,
                        label: data[x]
                    })
                });
                setPartData(respData);
            }).catch(err => {
                console.log(err);
            })
    }, []);


    const onPaste = (e) => {
        if (e.clipboardData) {
            let items = e.clipboardData.items;
            for (let item of items) {
                if (item.kind === 'file') {
                    var pasteFile = item.getAsFile();
                    
                    form.setFieldsValue({ 'img': pasteFile });
                    setImg(pasteFile);
                }
            }
        }
    };

    const getClickedImage = (e) => {
        
        if (e.target.files[0].type.includes('image/')) {
            setImg(e.target.files[0]);
            form.setFieldsValue({ 'img': e.target.files[0] });
        } else {
            notification.error({ message: 'Please Select image file only' })
        }
    }

    const uploadImg = (values) => {
        if(typeof(values['img']) === 'string'){
            notification.error({ message: 'Please Select image file only' });
            return;
        }
        let fileType = values['img'].type;
        if (!fileType.includes('image/')) {
            notification.error({ message: 'Please Select image file only' });
            return;
        };
        setLoading(true);
        let formData = new FormData();
        Object.keys(values).forEach(x => {
            formData.append(x, values[x]);
        })
        liracrypt.uploadFile('/image/binary', formData)
            .then(res => {
                
                setResponseImg(res.data.data);
                notification.success({ message: 'Uploaded Successfully' });
                form.resetFields();
                setImg(null);
                imgInputRef.current.value = '';
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                console.log(err);
            });
    }

    const resetImg = () => {
        form.setFieldsValue({ 'img': null });
        imgInputRef.current.value = '';
        setImg(null)
    };
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <Form
                form={form}
                onFinish={uploadImg}
                style={{ width: '45%' }}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                layout="horizontal"
                colon={false}
                size="large"
            >
                <Form.Item
                    name={"pno"}
                    label={"PartNo"}
                    style={{ marginRight: "10px", fontWeight: 600 }}
                    rules={[
                        {
                            required: true,
                            message: 'Please Select One',
                        },
                    ]}
                >
                    <Select
                        showSearch={true}
                        placeholder={'Please Select'}
                        defaultActiveFirstOption={true}
                        disabled={false}
                        options={partData || []}
                    />
                </Form.Item>
                <Form.Item
                    labelAlign='left'
                    name={"img"}
                    label={"Image"}
                    style={{ marginRight: "10px", fontWeight: 600 }}
                    rules={[
                        {
                            required: true,
                            message: 'Please add image',
                        },
                    ]}
                >
                    {
                        img ? (
                            <div className='uploaded-img' onClick={resetImg}>
                                <div className="img">
                                    <img
                                        src={URL.createObjectURL(img)}
                                    />
                                </div>
                                <div className='img-delete-icon'>
                                    <span>
                                        <DeleteOutlined className="img-trash" />
                                    </span>
                                </div>
                            </div>
                        ) : <Input placeholder='Paste your image' style={{ backgroundColor: '#ffffff', height: '31px !important' }} onPaste={onPaste} />
                    }
                </Form.Item>
                <p className='text-center' style={{ fontSize: 20, color: '#ffffff', textAlign: 'center' }}>Or</p>
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                    <Button onClick={() => { imgInputRef.current.click() }} type="primary">Click To Upload</Button>
                    <input accept='.png, .jpg, .jpeg' ref={imgInputRef} type="file" style={{ visibility: 'hidden' }} onChange={getClickedImage} />
                </div>
                <ButtonPicker loading={loading} disabled={loading} form={form} submitBtnId="submitImg" submitButtonText={'Submit'} onCancel={resetImg} cancelButtonText="Reset" />
            </Form >
            {
                responseImg && (
                    <div style={{ marginTop: 15, padding: 20, width: '100%', textAlign: 'center' }}>
                        <img src={responseImg} alt="result" />
                    </div>
                )
            }

        </div >
    )
};

export default ImageUpload;